<template>
  <div class="login-container">
    <div class="login-card">
      <!-- Logo Section -->
      <div class="logo-section">
        <img src="../assets/logo.png" alt="KLIMBUD Logo" class="logo-image"> 
      </div>

      <!-- Header -->
      <div class="login-header">
        <h1 class="login-title">Witaj ponownie! 👋</h1>
        <p class="login-subtitle">Zaloguj się do systemu KLIMBUD CRM</p>
      </div>

      <!-- Form -->
      <form class="login-form" @submit.prevent="login">
        <div class="form-group">
          <label for="inputEmail" class="form-label">Adres email</label>
          <input 
            v-model.trim="loginForm.email" 
            id="inputEmail" 
            type="email" 
            class="form-input" 
            placeholder="twoj@email.pl" 
            required 
            autofocus
          >
        </div>

        <div class="form-group">
          <label for="inputPassword" class="form-label">Hasło</label>
          <input 
            v-model.trim="loginForm.password" 
            id="inputPassword" 
            type="password" 
            class="form-input" 
            placeholder="Wprowadź hasło" 
            required
          >
        </div>

        <div class="form-options">
          <label class="checkbox-label">
            <input type="checkbox" class="checkbox-input">
            <span>Zapamiętaj mnie</span>
          </label>
        </div>

        <button type="submit" class="login-button">
          <span class="button-text">Zaloguj się</span>
          <span class="button-icon">→</span>
        </button>
      </form>

      <!-- Footer -->
      <div class="login-footer">
        <p class="footer-text">
          © 2026 <a href="https://2qbs.pl" target="_blank" class="footer-link">2Qbs</a>
        </p>
        <p class="version-text" @click="openVersionModal">KLIMBUD CRM v3.6</p>
      </div>
    </div>

    <version-modal></version-modal>
  </div>
</template>
<script>
import VersionModal from "../components/VersionModal";

export default {
  components: {
    "version-modal": VersionModal,
  },
  data() {
    return {
      loginForm: {
        email: '',
        password: '',
      },
      signupForm: {
        name: '',
        title: '',
        email: '',
        password: ''
      },
      showLoginForm: true,
      showPasswordReset: false,
    };
  },
  methods: {
    toggleForm() {
      this.showLoginForm = !this.showLoginForm;
    },
    tooglePasswordReset() {
      this.showPasswordReset = !this.showPasswordReset;
    },
    login() {
      this.$store.dispatch('login', {
        email: this.loginForm.email,
        password: this.loginForm.password
      });
    },
    signup() {
      this.$store.dispatch('signup', {
        email: this.signupForm.email,
        password: this.signupForm.password,
        name: this.signupForm.name,
        title: this.signupForm.title
      });
    },
    openVersionModal() {
      this.$modal.show("version-modal");
    },
  }
};
</script>

<style scoped>
.login-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 20px;
}

.login-card {
  background: white;
  border-radius: 24px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  padding: 48px 40px;
  width: 100%;
  max-width: 440px;
  animation: slideUp 0.5s ease-out;
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Logo */
.logo-section {
  text-align: center;
  margin-bottom: 32px;
}

.logo-image {
  width: 200px;
  height: auto;
  display: inline-block;
}

/* Header */
.login-header {
  text-align: center;
  margin-bottom: 32px;
}

.login-title {
  font-size: 28px;
  font-weight: 700;
  color: #2c3e50;
  margin: 0 0 8px;
  letter-spacing: -0.5px;
}

.login-subtitle {
  font-size: 15px;
  color: #6b7785;
  margin: 0;
  font-weight: 400;
}

/* Form */
.login-form {
  margin-bottom: 32px;
}

.form-group {
  margin-bottom: 20px;
}

.form-label {
  display: block;
  font-size: 14px;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 8px;
}

.form-input {
  width: 100%;
  padding: 14px 16px;
  font-size: 15px;
  border: 2px solid #e9ecef;
  border-radius: 12px;
  transition: all 0.3s ease;
  background: #f8f9fa;
  color: #2c3e50;
  font-family: inherit;
}

.form-input:focus {
  outline: none;
  border-color: #667eea;
  background: white;
  box-shadow: 0 0 0 4px rgba(102, 126, 234, 0.1);
}

.form-input::placeholder {
  color: #adb5bd;
}

.form-options {
  margin-bottom: 24px;
}

.checkbox-label {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-size: 14px;
  color: #4a5568;
  user-select: none;
}

.checkbox-input {
  width: 18px;
  height: 18px;
  cursor: pointer;
  accent-color: #667eea;
}

/* Button */
.login-button {
  width: 100%;
  padding: 16px 24px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  box-shadow: 0 4px 16px rgba(102, 126, 234, 0.4);
}

.login-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 24px rgba(102, 126, 234, 0.5);
}

.login-button:active {
  transform: translateY(0);
}

.button-icon {
  font-size: 20px;
  transition: transform 0.3s ease;
}

.login-button:hover .button-icon {
  transform: translateX(4px);
}

/* Footer */
.login-footer {
  text-align: center;
  padding-top: 24px;
  border-top: 1px solid #e9ecef;
}

.footer-text {
  font-size: 13px;
  color: #6b7785;
  margin: 0 0 8px;
}

.footer-link {
  color: #667eea;
  text-decoration: none;
  font-weight: 600;
  transition: color 0.3s ease;
}

.footer-link:hover {
  color: #764ba2;
}

.version-text {
  font-size: 11px;
  color: #adb5bd;
  margin: 0;
  font-weight: 600;
  letter-spacing: 0.5px;
  cursor: pointer;
  transition: color 0.3s ease;
}

.version-text:hover {
  color: #667eea;
}

/* Responsive */
@media (max-width: 768px) {
  .login-card {
    padding: 32px 24px;
    border-radius: 20px;
  }

  .logo-image {
    width: 160px;
  }

  .login-title {
    font-size: 24px;
  }

  .login-subtitle {
    font-size: 14px;
  }

  .form-input {
    padding: 12px 14px;
    font-size: 14px;
  }

  .login-button {
    padding: 14px 20px;
    font-size: 15px;
  }
}
</style>